import { apiVersion } from './apis.const';
import { transformResponse } from './apis.util';
import { baseApi } from './base.api';
import { IDecalOrder } from '../../models/cart.model';

const decalOrderUrl = ({ orgSlug }: { orgSlug: string }) => `/${orgSlug}/${apiVersion}/decal-order`;

/**
 * Create APIs
 */
export const decalOrderApi = baseApi.injectEndpoints({
  overrideExisting: false,

  endpoints: (build) => ({
    getCountItemsInCart: build.query<GetCountRes, ApiRequest>({
      query: ({ orgSlug }) => ({
        url: `${decalOrderUrl({ orgSlug })}/count`,
      }),
      transformResponse,
      providesTags: ['ItemsInCartCount'],
    }),
    getItemsInCart: build.query<IDecalOrder, ApiRequest>({
      query: ({ orgSlug }) => ({
        url: `${decalOrderUrl({ orgSlug })}`,
      }),
      transformResponse,
      providesTags: ['ItemsInCart'],
    }),
    addItemsToCart: build.mutation<IDecalOrder, AddItemToCartReq>({
      query: ({ orgSlug, body }) => {
        console.log({ body });
        return {
          url: `${decalOrderUrl({ orgSlug })}`,
          method: 'POST',
          body,
        };
      },
      transformResponse,
      invalidatesTags: ['ItemsInCartCount', 'ItemsInCart'],
    }),
    deleteItemsFromCart: build.mutation<EmptyRes, DeleteItemFromCartReq>({
      query: ({ orgSlug, zoneId }) => ({
        url: `${decalOrderUrl({ orgSlug })}/${zoneId}`,
        method: 'DELETE',
      }),
      transformResponse,
      invalidatesTags: ['ItemsInCartCount', 'ItemsInCart'],
    }),
    placeOrder: build.mutation<EmptyRes, ApiRequest>({
      query: ({ orgSlug }) => ({
        url: `${decalOrderUrl({ orgSlug })}/place-order`,
        method: 'POST',
      }),
      transformResponse,
    }),
  }),
});

export const {
  useGetCountItemsInCartQuery,
  useGetItemsInCartQuery,
  useAddItemsToCartMutation,
  useDeleteItemsFromCartMutation,
  usePlaceOrderMutation,
} = decalOrderApi;

type EmptyRes = {};
type ApiRequest = { orgSlug: string };
type GetCountRes = {
  count: number;
};

type AddItemToCartReq = {
  orgSlug: string;
  body: {
    zones: {
      zone_id: number;
      quantity: number;
    }[];
  };
};

type DeleteItemFromCartReq = { orgSlug: string; zoneId: number };
